import React, { useEffect } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import "./LoginTwitterSuccess.css";

function LoginTwitterSuccess() {
  const client = JSON.parse(localStorage.getItem("CLIENT"));
  const campaignLink = localStorage.getItem("campaignLink");
  const history = useHistory();
  useEffect(() => {
    if (campaignLink != null) {
      setTimeout((window.location.href = `${campaignLink}`), 3000);
    }
  }, []);
  return (
    <div className="signup-container">
      <div className="signup-content">
        <h1 className="signup-title">Login With Twitter</h1>
        <p className="">
          Please go back to Moverse App to do your event and take rewards.
        </p>
      </div>
    </div>
  );
}

export default LoginTwitterSuccess;



// WEBPACK FOOTER //
// ./src/user/login_with_twitter/login_with_twitter_success/LoginTwitterSuccess.js